import { Dispatch, SetStateAction } from "react";

import { Product } from "../../types/product";
import { PosModal } from "../reuseables/modal.comp";
import CustomProduct from "./CustomProduct.comp";

interface CustomProductModalProps {
  customProduct: Product;
  setShowCustomProduct: Dispatch<SetStateAction<boolean>>;
}

export default function CustomProductModal({ customProduct, setShowCustomProduct }: CustomProductModalProps) {
  return (
    <PosModal setModalOpened={setShowCustomProduct} variant="LARGE" skipClickOutside>
      <section className="flex flex-col items-center w-4/5 mx-auto min-h-[400px]">
        <CustomProduct customProduct={customProduct} onProductAdded={() => setShowCustomProduct(false)} />
      </section>
    </PosModal>
  );
}
